/* Yuvakart — lead capture inside the "Need Help Choosing?" quiz.

   Shows a details form immediately BEFORE the final question (Rashi),
   then reveals that question once submitted.
     Name           required
     Age            required
     Mobile         required, Indian 10-digit
     Date of birth  optional
     Time of birth  optional

   Written as an add-on, so the 335 KB quiz asset is untouched. It
   watches #ymc-body for re-renders, reads the "Step n of t" counter,
   and fires when n === t.

   Endpoint: set window.YK_LEAD_ENDPOINT to a Google Apps Script web
   app URL. Until that is set, leads are still stored in localStorage
   under yk_leads so nothing is lost. */
(function(){

  var FLAG  = 'yk_lead_done';
  var STORE = 'yk_leads';
  var shown = false;

  function endpoint(){ return window.YK_LEAD_ENDPOINT || ''; }

  var CSS = [
  '.ykl{position:absolute;inset:0;z-index:40;display:flex;flex-direction:column;',
    'background:#fbf6ec;overflow-y:auto;-webkit-overflow-scrolling:touch;',
    'padding:26px 24px 28px;animation:yklIn .45s cubic-bezier(.22,1,.36,1) both}',
  '@keyframes yklIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}',
  '.ykl__eye{font-size:11px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;',
    'color:#c9a24b;margin:0 0 8px}',
  '.ykl__h{font-family:Georgia,serif;font-size:23px;font-weight:700;color:#2a2118;margin:0 0 6px;line-height:1.2}',
  '.ykl__p{font-size:13.5px;line-height:1.6;color:#6e6355;margin:0 0 18px}',
  '.ykl__f{display:flex;flex-direction:column;gap:13px}',
  '.ykl__row{display:flex;gap:11px}',
  '.ykl__row > *{flex:1 1 0;min-width:0}',
  '.ykl__lab{display:block;font-size:11.5px;font-weight:700;letter-spacing:.04em;',
    'text-transform:uppercase;color:#6e6355;margin:0 0 5px}',
  '.ykl__opt{font-weight:600;color:#a2947c;text-transform:none;letter-spacing:0}',
  '.ykl__in{width:100%;box-sizing:border-box;padding:12px 13px;font:inherit;font-size:15px;',
    'color:#2a2118;background:#fff;border:1px solid #e7d3ae;border-radius:11px;outline:none;',
    'transition:border-color .2s ease, box-shadow .2s ease;-webkit-appearance:none}',
  '.ykl__in:focus{border-color:#c9a24b;box-shadow:0 0 0 3px rgba(201,162,75,.16)}',
  '.ykl__in.bad{border-color:#b8383b;box-shadow:0 0 0 3px rgba(184,56,59,.14)}',
  '.ykl__err{font-size:12px;color:#b8383b;margin:4px 0 0;display:none}',
  '.ykl__err.on{display:block}',
  '.ykl__con{display:flex;gap:9px;align-items:flex-start;margin:4px 0 2px}',
  '.ykl__con input{margin:2px 0 0;width:16px;height:16px;accent-color:#c9a24b;flex:none}',
  '.ykl__con label{font-size:12px;line-height:1.5;color:#6e6355}',
  '.ykl__con a{color:#8a6a1e}',
  '.ykl__go{margin-top:6px;padding:14px 20px;border:0;border-radius:999px;cursor:pointer;',
    'background:#1c1710;color:#f6e7c9;font:inherit;font-size:15px;font-weight:800;letter-spacing:.02em;',
    'transition:transform .3s cubic-bezier(.22,1,.36,1), opacity .2s ease}',
  '.ykl__go:hover{transform:translateY(-1px)}',
  '.ykl__go[disabled]{opacity:.6;cursor:default;transform:none}',
  '.ykl__note{font-size:11.5px;color:#a2947c;margin:12px 0 0;text-align:center}',
  '@media (min-width:620px){ .ykl{padding:32px 34px 34px} .ykl__h{font-size:26px} }'
  ].join('');

  function style(){
    if (document.getElementById('ykl-css')) return;
    var s = document.createElement('style');
    s.id = 'ykl-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function isLastStep(){
    var el = document.querySelector('#ymc-body .ymc-step');
    if (!el) return false;
    var nums = (el.textContent || '').match(/\d+/g);
    if (!nums || nums.length < 2) return false;
    return parseInt(nums[0], 10) === parseInt(nums[nums.length - 1], 10);
  }

  function save(lead){
    try {
      var all = JSON.parse(localStorage.getItem(STORE) || '[]');
      all.push(lead);
      localStorage.setItem(STORE, JSON.stringify(all));
    } catch(e){}
  }

  function send(lead){
    var url = endpoint();
    if (!url) return Promise.resolve();
    var body = Object.keys(lead).map(function(k){
      return encodeURIComponent(k) + '=' + encodeURIComponent(lead[k]);
    }).join('&');
    return fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body
    }).catch(function(){});
  }

  function build(){
    var modal = document.getElementById('ymc-modal');
    var body  = document.getElementById('ymc-body');
    if (!modal || !body || modal.querySelector('.ykl')) return;

    style();
    if (getComputedStyle(modal).position === 'static') modal.style.position = 'relative';

    var w = document.createElement('div');
    w.className = 'ykl';
    w.innerHTML =
      '<p class="ykl__eye">Almost there</p>' +
      '<h3 class="ykl__h">A few details for your personal recommendation</h3>' +
      '<p class="ykl__p">Our team checks your suggestion against your birth details before you buy. We will only contact you about this recommendation.</p>' +
      '<div class="ykl__f">' +
        '<div>' +
          '<label class="ykl__lab" for="ykl-name">Full name</label>' +
          '<input class="ykl__in" id="ykl-name" type="text" autocomplete="name" placeholder="Your name">' +
          '<p class="ykl__err" id="ykl-e-name">Please enter your name</p>' +
        '</div>' +
        '<div class="ykl__row">' +
          '<div>' +
            '<label class="ykl__lab" for="ykl-age">Age</label>' +
            '<input class="ykl__in" id="ykl-age" type="number" inputmode="numeric" min="1" max="120" placeholder="e.g. 32">' +
            '<p class="ykl__err" id="ykl-e-age">Enter a valid age</p>' +
          '</div>' +
          '<div>' +
            '<label class="ykl__lab" for="ykl-phone">Mobile number</label>' +
            '<input class="ykl__in" id="ykl-phone" type="tel" inputmode="numeric" autocomplete="tel" maxlength="10" placeholder="10 digits">' +
            '<p class="ykl__err" id="ykl-e-phone">Enter a valid 10-digit mobile</p>' +
          '</div>' +
        '</div>' +
        '<div class="ykl__row">' +
          '<div>' +
            '<label class="ykl__lab" for="ykl-dob">Date of birth <span class="ykl__opt">(optional)</span></label>' +
            '<input class="ykl__in" id="ykl-dob" type="date">' +
          '</div>' +
          '<div>' +
            '<label class="ykl__lab" for="ykl-tob">Time of birth <span class="ykl__opt">(optional)</span></label>' +
            '<input class="ykl__in" id="ykl-tob" type="time">' +
          '</div>' +
        '</div>' +
        '<div class="ykl__con">' +
          '<input type="checkbox" id="ykl-con">' +
          '<label for="ykl-con">I agree to be contacted on WhatsApp, call or email about my recommendation, and accept the <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</label>' +
        '</div>' +
        '<p class="ykl__err" id="ykl-e-con">Please accept to continue</p>' +
        '<button class="ykl__go" id="ykl-go" type="button">Continue to my result</button>' +
        '<p class="ykl__note">Birth date and time are optional. They only make the suggestion more precise.</p>' +
      '</div>';

    modal.appendChild(w);

    var q  = function(id){ return document.getElementById(id); };
    var go = q('ykl-go');

    function bad(input, errId, isBad){
      if (input) input.className = 'ykl__in' + (isBad ? ' bad' : '');
      var e = q(errId);
      if (e) e.className = 'ykl__err' + (isBad ? ' on' : '');
      return !isBad;
    }

    go.addEventListener('click', function(){
      var name  = (q('ykl-name').value || '').trim();
      var age   = (q('ykl-age').value || '').trim();
      var phone = (q('ykl-phone').value || '').replace(/\D/g, '');
      var dob   = q('ykl-dob').value || '';
      var tob   = q('ykl-tob').value || '';
      var con   = q('ykl-con').checked;

      var ok = true;
      ok = bad(q('ykl-name'),  'ykl-e-name',  name.length < 2) && ok;
      ok = bad(q('ykl-age'),   'ykl-e-age',   !(age >= 1 && age <= 120)) && ok;
      ok = bad(q('ykl-phone'), 'ykl-e-phone', !/^[6-9]\d{9}$/.test(phone)) && ok;
      ok = bad(null,           'ykl-e-con',   !con) && ok;
      if (!ok) return;

      go.setAttribute('disabled', 'disabled');
      go.textContent = 'Saving...';

      var lead = {
        name: name,
        age: age,
        phone: phone,
        dob: dob,
        tob: tob,
        consent: 'yes',
        source: 'Need Help Choosing',
        page: location.pathname,
        at: new Date().toISOString()
      };

      save(lead);

      send(lead).then(function(){
        try { sessionStorage.setItem(FLAG, '1'); } catch(e){}
        if (w.parentNode) w.parentNode.removeChild(w);
      });
    });

    var ins = w.querySelectorAll('.ykl__in');
    for (var i = 0; i < ins.length; i++){
      ins[i].addEventListener('keydown', function(e){
        if (e.key !== 'Enter') return;
        e.preventDefault();
        go.click();
      });
    }
  }

  function check(){
    try { if (sessionStorage.getItem(FLAG)) return; } catch(e){}
    var overlay = document.getElementById('ymc-overlay');
    if (!overlay || overlay.className.indexOf('ymc-open') === -1) return;
    if (!isLastStep()) return;
    if (shown && document.querySelector('#ymc-modal .ykl')) return;
    shown = true;
    build();
  }

  function watch(){
    var body = document.getElementById('ymc-body');
    if (!body || body.getAttribute('data-ykl')) return;
    body.setAttribute('data-ykl', '1');
    try {
      new MutationObserver(function(){ setTimeout(check, 30); })
        .observe(body, { childList:true, subtree:true });
    } catch(e){}
  }

  function boot(){ watch(); check(); }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  setTimeout(boot, 600);
  setTimeout(boot, 1600);
  window.addEventListener('load', boot);

  try {
    new MutationObserver(function(){ boot(); })
      .observe(document.body, { childList:true });
  } catch(e){}
})();